import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { ApiError, tinctApi } from '../../api';

export type GenerateAdPageParams = {
  campaignId: string;
  adsCampaignId: string;
  userPrompt?: string;
};

export const generateAdPage = async (
  params: GenerateAdPageParams,
): Promise<void> => {
  return await tinctApi.campaigns.generateAdPage(params.campaignId, {
    adsCampaignId: params.adsCampaignId,
    userPrompt: params.userPrompt,
  });
};

export const useGenerateAdPage = (
  options?: Omit<
    UseMutationOptions<void, ApiError, GenerateAdPageParams>,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: generateAdPage,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ['pages'] });
      queryClient.invalidateQueries({
        queryKey: ['campaign', args[1].campaignId],
      });
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
